module.exports = __webpack_public_path__ + "static/img/jmt5.1ad7706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/img/jmt5.jpg
// module id = 8GgR
// module chunks = 1